import request from '@/utils/request'



export function loadPaginatedMatchinPayHistory(page) {
  return request({ url: 'vmatchinpayhistory', method: 'post', data: {'page': page} })
} 

export function process_matchinpayReload(param) {
  return request({ url: 'vprocessmatchinpayreload', method: 'post', data: param})
} 


export function process_matchinpayOTP(param) {
  return request({ url: 'vmatchinpayvalidateotp', method: 'post', data: param})
} 


export function getBiboMerchantDetails(param) {
  return request({ url: 'vgetbibomerchantdetailsthruqrcode', method: 'post', data: param})
} 


export function getMatchinPayBalance() {
  return request({ url: 'vgetMatchinPayBalance', method: 'get'})
} 


export function proceedMatchinPayQRPayment(param) {
  return request({ url: 'vproceedqrpaymentmatchinpay', method: 'post', data: param})
} 

export function process_matchinpayReload_DLQR(param) {
  return request({ url: 'vprocessmatchinpayreloaddlqr', method: 'post', data: param})
} 